/* eslint-disable react/destructuring-assignment */
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import LocationForm from '../Form';
import { useProjectsState } from '../../../../hooks/projectsInfo';
import { useAddLocationMutation, useUpdateLocationMutation } from '../../../../../graphql/generated/graphql';
import { IDTOLocation, IFiles } from '../../../../config/interfaces';
import { makeUriMap } from '../../../../helper/converters';
import { setAlertDescription } from '../../../../hooks/actions';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  maxWidth: 500,
  bgcolor: '#fff',
  boxShadow: 24,
  borderRadius: '20px',
  p: 4,
};

const LocationModal = (props: any) => {
  const { item } = props;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    props.close();
    setOpen(false);
  };
  const projectsState = useProjectsState();
  const currentProject = projectsState.projectId.get();
  const [addLocation] = useAddLocationMutation();
  const [updateLocation] = useUpdateLocationMutation();
  const [loading, setLoading] = useState<boolean>(false)

  const onSubmit = async (data: IDTOLocation, files: [IFiles]) => {
    try {
      setLoading(true);
      await addLocation({
        variables: {
          ...data,
          country_id: 1,
          project_id: currentProject || '',
          link_maps_set_address: data.set_address
            ? makeUriMap(encodeURIComponent(`${data.set_address}, ${data.zipcode}`)) : '',
          link_maps_hospital_address: data.nearest_hospital_address
            ? makeUriMap(encodeURIComponent(`${data.nearest_hospital_address}, ${data.zipcode}`)) : '',
          link_maps_parking_address: data.parking_address
            ? makeUriMap(encodeURIComponent(`${data.parking_address}, ${data.zipcode}`)) : '',
          files: files.map((file: IFiles) => ({
            file_name: file.name,
            file: file.base64,
          })),
        },
      }).then((res) => {
        setLoading(false)
        setAlertDescription({
          open: true,
          message: 'The Location has been created succesfully',
          severity: 'success',
        })
      });
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  const onSubmitEdit = async (data: any, files: [any], filesToDelete: [any], changeStateFile: boolean) => {
    try {
      setLoading(true);
      await updateLocation({
        variables: {
          ...data,
          country_id: 1,
          link_maps_set_address: data.set_address
            ? makeUriMap(encodeURIComponent(`${data.set_address}, ${data.zipcode}`)) : '',
          link_maps_hospital_address: data.nearest_hospital_address
            ? makeUriMap(encodeURIComponent(`${data.nearest_hospital_address}, ${data.zipcode}`)) : '',
          link_maps_parking_address: data.parking_address
            ? makeUriMap(encodeURIComponent(`${data.parking_address}, ${data.zipcode}`)) : '',
          location_id: item?.id || '',
          ...(changeStateFile ? {
            add_files: files.map((file: any) => ({
              file_name: file.name ? file.name : file.file_name,
              file: file.base64 ? file.base64 : file.file,
            })),
          } : { add_files: [] }),
          ...(filesToDelete.length > 0 ? { delete_files: filesToDelete } : { delete_files: [] }),
        },
      }).then((res) => {
        setLoading(false)
        setAlertDescription({
          open: true,
          message: 'The Location has been edited succesfully',
          severity: 'success',
        })
        handleClose()
      });
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (props?.open) {
      handleOpen();
    }
  }, [props?.open]);

  return (
    <>
      <Modal
        open={open}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          overflow: 'scroll'
        }}
      >
        <Box sx={style}>
          <LocationForm
            handleSubmit={onSubmit}
            handleSubmitEdit={onSubmitEdit}
            item={item}
            loading={loading}
          />
        </Box>
      </Modal>
    </>
  );
}
export default LocationModal;
